module.exports = __webpack_public_path__ + "img/pxpay.7db35f74.svg";